<template>
    <div class="contest">
        <v-container class="custom-container responsive-height">
            <v-row dense>
                <v-col cols="12">
                    <v-card class="pa-5 pb-0" elevation="0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
                        <v-row dense>
                            <v-col cols="12" sm="6" md="7" lg="7">
                                <v-card class="elevation-0 px-5 py-3 rounded-0 pending-content"
                                    :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                                    <v-card-actions class="title custom-border-bottom">
                                        <h3>Leaderboard</h3>
                                        <p>Total Contestant : <span>{{ upcomingcontest?.total_contestants || 0 }}</span>
                                        </p>
                                    </v-card-actions>
                                    <v-card-text class="custom-card-text">
                                        <v-img class="mx-auto" src="@/assets/waiting.png" width="193"
                                            height="153"></v-img>
                                        <p>Please Wait, Contest Will Start in </p>
                                        <timer-view :timer="upcomingcontest"></timer-view>
                                    </v-card-text>
                                    <v-card-text class="notifications custom-border-bottom">
                                        <div class="badge-wrapper">
                                            <v-img class="mx-auto" src="@/assets/bell.png" width="44"
                                                height="39"></v-img>
                                            <span>{{ pendingparticipants || '0' }}</span>
                                        </div>
                                        <v-btn :ripple="false" tile large elevation="0" to="/join-request"
                                            class="custom-btn font-weight-bold" color="#039de9">

                                            See <span class="mx-1"> {{ pendingparticipants || '0' }} </span> Pending
                                            Request
                                        </v-btn>
                                    </v-card-text>
                                </v-card>
                                <v-card class="elevation-0 rounded-0 pending-content"
                                    :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                                    <v-card-actions class="title px-5">
                                        <h3>Approved Contestants <span>{{ approvedparticipants.length }}</span></h3>
                                        <p>Total Amount: <span>{{ totalAmount }}</span></p>
                                    </v-card-actions>
                                    <pending-data-table :participants="approvedparticipants"></pending-data-table>
                                </v-card>
                            </v-col>
                            <v-col cols="12" sm="6" md="5" lg="5">
                                <pending-contest-card :contest="upcomingcontest"></pending-contest-card>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import AddContestModal from '@/components/Contest/AddContestModal.vue';
import ContestCard from '@/components/Contest/ContestCard.vue';
import PendingContestCard from '@/components/Contest/PendingContestCard.vue';
import PendingDataTable from '@/components/Contest/PendingDataTable.vue';
import TimerView from '@/components/Contest/TimerView.vue';
import { CONTEST__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
    components: { AddContestModal, ContestCard, PendingContestCard, PendingDataTable, TimerView },
    computed: {
        ...mapState("contest", ["upcomingcontest", "approvedparticipants", "pendingparticipants"]),
        totalAmount() {
            const sum = this.approvedparticipants.reduce((total, participant) => {
                return total + (participant.amount || 0)
            }, 0)

            return `$${sum.toFixed(2)}`
        }
    },
    methods: {
        ...mapActions("contest", [CONTEST__ACTIONS.VIEWUPCOMINGCONTEST, CONTEST__ACTIONS.APPROVEDPARTICIPANTS, CONTEST__ACTIONS.PENDINGPARTICIPANTS]),
    },
    async mounted() {
        this[CONTEST__ACTIONS.VIEWUPCOMINGCONTEST](this.$route.query.id);
        this[CONTEST__ACTIONS.APPROVEDPARTICIPANTS]();
        this[CONTEST__ACTIONS.PENDINGPARTICIPANTS](this.$route.query.id);
    }
}
</script>
